import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import routes from './routes';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';

import './styles/reset.css';
import './styles/index.css';
import '@/assets/iconfont/iconfont.css';

import { DrawerProvider } from '@/context/DrawerContext';
import i18n, { DEFAULT_LANGUAGE } from '@/utils/i18n.ts';
import { Toaster } from 'react-hot-toast';

import jsFunc from './utils/jsFunc';
import { initSentry } from './utils/Sentry/sentryConfig';
window.jsFunc = jsFunc;
window._UNITY_PARAMS = {
  language: i18n.language || DEFAULT_LANGUAGE,
};
document.documentElement.lang = i18n.language || DEFAULT_LANGUAGE;
if (import.meta.env.MODE === 'prod') {
  // 移除console.log
  console.log = () => {};
}
// window.navigator = {
//   language: 'en-US',
// };
initSentry();
function App() {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider
      locale={i18n.resolvedLanguage === 'en-US' ? enUS : zhCN}
      theme={{
        token: {
          colorPrimary: '#ff4d4f', // 设置选中时的主色，比如红色
        },
        components: {
          Slider: {
            railBg: '#ffffff55',
            railHoverBg: '#ffffff55',
            trackBg: '#ffffffaa',
            trackHoverBg: '#ffffffaa',
          },
          Radio: {
            buttonColor: '#fff',
          },
        },
      }}>
      <Provider store={store}>
        <DrawerProvider>
          <RouterProvider router={routes} />
        </DrawerProvider>
        <Toaster />
      </Provider>
    </ConfigProvider>
  );
}
createRoot(document.getElementById('root')).render(<App />);
console.log('调试-2025.0526');
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, [child]);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error(
          'Cannot insert before a reference node from a different parent',
          referenceNode,
          this,
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, [newNode, referenceNode]);
  };
}
